import React, { useRef } from "react";
import { useValidate } from "formvalidation/hooks";
import { saveOrCancel } from "utilities/inputUtils";
import { InputBase } from "components/Atoms/formInputs/InputBase";

interface Props {
  value: string
  onChanged: (newBsbCode: string) => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  validatorKey: string
}

const BsbCodeInput = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const isValidInput = (input: string) => {
    if (input.trim().length === 0) return true;

    return /\d{3}-\d{3}/.test(input) && input.length === 7;
  };

  const validate = async (input: string) => {
    const isValid = isValidInput(input);
    return isValid;
  };

  const formatInput = (input: string, e?) => {
    if (isValidInput(input)) {
      e?.preventDefault();
      props.onChanged(input);
      return input;
    }

    const digits = input.trim().replace(/\D/g, "");
    if (digits.length === 6) {
      e?.preventDefault();
      const formatted = digits.substring(0, 3) + "-" + digits.substring(3);
      props.onChanged(formatted);

      return formatted;
    }

    return false;
  };

  const onPaste = (e) => {
    const text: string = e.clipboardData.getData("text").trim();
    formatInput(text, e);
  };

  const onBlur = () => {
    formatInput(props.value);
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.BankAccount.BsbCode,
    value: props.value,
    validate: validate,
    ref: inputRef
  })

  return <InputBase
    ref={inputRef}
    value={props.value}
    onChange={props.onChanged}
    maxLength={serverReference.constants.bankAccount.maxBsbCodeLength}
    onPaste={onPaste}
    error={validation.error.hasError}
    onBlur={onBlur}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    placeholder="000-000"
    focusOnMount={props.focusOnMount}
  />;
};

export default BsbCodeInput;